import {useMutation} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

export const useDeleteField = (mid: string) => {
    const locale = useLocale();

    return useMutation<
        Api.Response.Template.SuccessBasicMessage,
        Error,
        {mid: string}
    >((formData) =>
        request({
            formData: toSnakeCase(formData),
            locale,
            method: 'POST',
            url: window.Urls.extendeddatafields_delete_view(mid),
        }),
    );
};
